import { useState } from 'react';
import { CaretDown, CaretRight, SquareHalf } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
import { ClickAwayListener, Fade, Popper, Skeleton } from '@mui/material';
import LatestToolTip from '@/components/Tooltip';

export const FilterDropDownPillDataCatalog = ({
  title,
  titleClassName,
  data = [],
  caretRight = true,
  sources,
  setSources,
  tableId,
  indiData,
  setSourcesTableMapping,
  setRef,
  active,
  columnListData,
  disabled,
  setActiveTable,
  hideIcon,
  listData,
}) => {
  const [anchorEl, setAnchorEl] = useState();
  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    if (indiData.column_count > 0) {
      setAnchorEl(event.currentTarget || event.current);
      setOpen((prev) => !prev);
      setActiveTable(open ? '' : tableId);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isChecked = (value) => {
    return sources[tableId]?.find((item) => item === value);
  };
  const handleChange = (value) => {
    if (isChecked(value)) {
      setSources((prev) => {
        let clonedData = structuredClone(sources);
        clonedData[tableId] = clonedData[tableId].filter(
          (item) => item !== value
        );
        if (clonedData[tableId].length === 0) {
          setSourcesTableMapping((sourcesTableMapping) => {
            let clonnedSourcesTableMapping =
              structuredClone(sourcesTableMapping);
            delete clonnedSourcesTableMapping[tableId];
            return clonnedSourcesTableMapping;
          });
          delete clonedData[tableId];
        }
        return clonedData;
      });
    } else {
      const item = data.find((e) => e === value);

      setSources((sources) => {
        let clonedData = structuredClone(sources);
        if (!clonedData?.[tableId]) {
          clonedData[`${tableId}`] = [];
          setSourcesTableMapping((sourcesTableMapping) => {
            let clonnedSourcesTableMapping =
              structuredClone(sourcesTableMapping);
            if (!clonnedSourcesTableMapping?.[tableId]) {
              clonnedSourcesTableMapping[`${tableId}`] = {};
              clonnedSourcesTableMapping[tableId]['datasource_description'] =
                indiData.datasource_description;
              clonnedSourcesTableMapping[tableId]['integrationId'] =
                indiData.integrationId;
              clonnedSourcesTableMapping[tableId]['tableName'] = indiData.name;
              clonnedSourcesTableMapping[tableId]['integration_logo'] =
                indiData.integration_logo;
              clonnedSourcesTableMapping[tableId]['platform'] =
                indiData.platform;
            }

            return clonnedSourcesTableMapping;
          });
        }
        clonedData[tableId].push(item);
        return clonedData;
      });
    }
  };

  return (
    <div className="flex items-center justify-center">
      <button
        onClick={handleClick}
        className={twMerge(
          `p-2 px-4 py-3 rounded-sm w-full font-normal text-xs flex justify-between items-center  ${
            disabled
              ? `text-t-disabled cursor-not-allowed`
              : `text-brand-ai-200 hover:bg-pv-primary-primary-50 `
          }`,
          `${active && 'bg-pv-primary-primary-50'}`,
          `${!hideIcon && 'pr-4'}`,
          titleClassName
        )}
      >
        {title}
        {caretRight ? <CaretRight size={15} /> : <CaretDown />}
      </button>
      <Popper
        open={open}
        anchorEl={anchorEl}
        transition
        placement={hideIcon ? 'left-start' : 'right-start'}
        sx={{ zIndex: 10 }}
        disablePortal={true}
        modifiers={[
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              altBoundary: true,
              tether: false,
              rootBoundary: 'viewport',
              // padding: 8,
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className="bg-white rounded-md shadow-lg mt-2">
              <ClickAwayListener onClickAway={handleClose}>
                <div>
                  {columnListData?.isLoading && data.length === 0 ? (
                    <div className="flex flex-col gap-4 p-4 w-72">
                      <Skeleton variant="rounded" height={20} />
                      <Skeleton variant="rounded" height={20} />
                      <Skeleton variant="rounded" height={20} />
                      <Skeleton variant="rounded" height={20} />
                      <Skeleton variant="rounded" height={20} />
                    </div>
                  ) : (
                    data.length > 0 && (
                      <div className="my-3 py-1">
                        <div
                          className="rounded-lg flex flex-col bg-white w-72 text-wrap max-h-40 overflow-y-auto mx-1.5"
                          ref={setRef}
                        >
                          {data.map((item, index) => {
                            return (
                              <div>
                                <label
                                  htmlFor={item}
                                  className={`px-4 flex items-center w-full gap-2 py-3 select-none w-full text-left text-xs truncate ${
                                    listData[index]?.disabledForGuidedAnalysis
                                      ? `text-t-disabled cursor-not-allowed`
                                      : `hover:bg-pv-primary-primary-50 text-brand-ai-200 cursor-pointer`
                                  }`}
                                  key={index}
                                >
                                  <input
                                    id={item}
                                    value={item}
                                    type="checkbox"
                                    checked={isChecked(item)}
                                    style={{ accentColor: '#3661ED' }}
                                    disabled={
                                      listData[index]?.disabledForGuidedAnalysis
                                    }
                                    onChange={() => handleChange(item)}
                                  />

                                  <div className="text-xs flex w-fit items-center gap-1 px-2 py-0.5 bg-pv-primary-primary-100 rounded-lg">
                                    <div>
                                      <SquareHalf />
                                    </div>
                                    <LatestToolTip
                                      title={item}
                                      placement="top"
                                      tooltipActive={
                                        !listData[index]
                                          ?.disabledForGuidedAnalysis
                                      }
                                      displayTooltipOnOverflow={true}
                                    >
                                      <div
                                        style={{
                                          display: 'inline-block',
                                          maxWidth: '190px',
                                          whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                          overflow: 'hidden',
                                        }}
                                      >
                                        {item}
                                      </div>
                                    </LatestToolTip>
                                  </div>
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </ClickAwayListener>
            </div>
          </Fade>
        )}
      </Popper>
    </div>
  );
};
